import { render, staticRenderFns } from "./SummaryMailButton.vue?vue&type=template&id=706ddda0&"
import script from "./SummaryMailButton.vue?vue&type=script&lang=ts&"
export * from "./SummaryMailButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports